<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				state: 'init',
				email: '',
				news: false,
				errors: null
			}
		},
		methods: {
			submit() {
				this.loading = true;
				this.errors = null;
				axios.post(this.route('login'), {
					email: this.email,
					news: this.news
				}).then(response => {
					if (response.status == 204) {
						window.location.reload(); 
					} else if (response.status == 201) {
						this.state = 'pending';
						this.loading = false;
					}
				}).catch(error => {
					if (error.response.data) {
						this.loading = false;
						this.errors = error.response.data.email;
					}
				});
			},
			reset() {
				window.location = this.route('index');
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Login.vue